class RyderMarqueetoLeft {
  constructor(el, direct) {
    this.hero = $(el)
      .parent()
      .get(0);
    this.wrapper = el;
    this.delta = 0;
    this.transform = 0;
    this.step = 1;
    this.direct = direct % 1;
    if (this.direct == 1) {
      this.wrapper.style.transform = `translate3d(-${this.wrapper.getBoundingClientRect()
        .width / 2}px, 0, 0)`;
      this.transform = -this.wrapper.getBoundingClientRect().width / 2;
    }
  }
  animate() {
    this.transform += this.step;
    if (this.direct == 1) {
      if (this.transform > 0) {
        this.transform = -this.wrapper.getBoundingClientRect().width / 2;
      }
      this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
    } else {
      if (this.transform > this.wrapper.getBoundingClientRect().width / 2) {
        this.transform = 0;
      }
      this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
    }
  }
  render() {
    this.scrollY = $(window).scrollTop();
    const bounding = this.hero.getBoundingClientRect();
    const distance =
      window.innerHeight + this.scrollY - (bounding.top + this.scrollY);
    const percentage =
      distance / ((window.innerHeight + bounding.height) / 100);
    if (percentage > 0 && percentage < 100) {
      this.animate();
    }
  }
  create() {
    gsap.ticker.add(this.render.bind(this));
  }
}

$(".marquee-left").each(function(i, el) {
  var $copy = $(el)
    .contents()
    .clone();
  $(el).append($copy);
  var ryderMarquee = new RyderMarqueetoLeft(el, i).create();
});

$(window)
  .on("resize", function () {
    if ($(this).width() > 1200) {
      if (window.device == "mobile") {
        location.reload();
      }
      window.device = "desktop";
    } else {
      if (window.device == "desktop") {
        location.reload();
      }
      window.device = "mobile";
    }

    // if ($(this).width() > 1100 && $(this).width() < 1400) {
    //   const notMac = navigator.userAgentData;

    //   if (notMac == undefined) {
    //     $("#landscape-lock").removeClass("hidden");
    //   }
    // }
  })
  .trigger("resize");

$("#preload").delay(1000).fadeOut(600);

// lock right click
$(document).bind("contextmenu", function (event) {
  return false;
});

$(".scrolldown").on("click", function () {
  gsap.to(window, {
    duration: 1.2,
    scrollTo: $(window).height(),
    ease: "power2.inOut",
  });
});

$(".backtotop").on("click", function () {
  gsap.to(window, {
    duration: 1.2,
    scrollTo: 0,
    ease: "power2.inOut",
  });
});

$("[data-share]").each((i, el) => {
  var type = el.dataset.share;
  $(el).click(function (e) {
    e.preventDefault();

    var winHeight = 360;
    var winWidth = 600;
    var winTop = screen.height / 2 - winHeight / 2;
    var winLeft = screen.width / 2 - winWidth / 2;
    var url = $(this).attr("href");

    if (type == "facebook") {
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "twitter") {
      window.open(
        "https://twitter.com/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "pinterest") {
      window.open(
        "https://www.pinterest.com/pin/create/button/?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "googleplus") {
      window.open(
        "https://plus.google.com/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "linkedin") {
      window.open(
        "https://www.linkedin.com/cws/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "weibo") {
      window.open(
        "https://service.weibo.com/share/share.php?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "line") {
      window.open("https://line.naver.jp/R/msg/text/?" + url);
    } else if (type == "instagram") {
      window.open("https://www.instagram.com/?url=" + url);
    }
  });
});

$(".menu").on("click", function () {
  gsap.timeline().to(".menuList >li a", {
    duration: 1,
    y: 0,
    stagger: {
      each: 0.1,
      // from: "end",
    },
    ease: "power2.Out",
  });
  $(".topmenu").addClass("is-show");
});
$(".topmenu .close").on("click", function () {
  gsap.delayedCall(0.5, function () {
    gsap.timeline().to(".menuList >li a", {
      duration: 0,
      y: '100%',
      ease: "none",
    });
  });
  $(".topmenu").removeClass("is-show");
});


// 選單下滑隱藏 快滾回去時消失
var _scrollLast = 0

$(window).on("scroll", () => {
	var _scrollTop = $(window).scrollTop()
	var _allBottom = $("body").height() - $(window).height() - 100

	if (_scrollTop < 0 || _scrollTop > _allBottom) {
		return false;
	}

	if (_scrollTop > 100) {
		if (_scrollTop > _scrollLast) {
			$(".topmenu-fixed").removeClass("is-show")
		} else {
			$(".topmenu-fixed").addClass("is-show")
		}
	} else {
		$(".topmenu-fixed").removeClass("is-show")
	}

	_scrollLast = _scrollTop
}).trigger("scroll")